<div class="asset-meta">
  <div
    class="asset-name"
    (click)="onThumbnailBarOpen.emit(!thumbnailBarOpen())"
    [appTooltip]="'Thumbnails'"
    tooltipKeyboardShortcut="↑ / ↓"
  >
    <span class="asset-name-span">
      {{ asset().name }}
    </span>
    <div class="asset-count" [class.center]="center()" [class.active]="thumbnailBarOpen()">
      <app-svg src="/assets/icons/12/arrow-down.svg"></app-svg>
    </div>
  </div>
</div>
